import * as React from 'react';
import classNames from 'classnames';
import s from './ProductFullPrice.scss';
import { PremiumCurrencyFormatter } from '@wix/premium-react-text';
import { Text } from 'wix-style-react';
import { UiProvider } from '../../providers/UiProvider';
import { RootStore, withInjectedRootStore } from '../../providers';
import { PlanType, Theme } from '../../enums';

const ProductFullPriceComp: React.FC<{
  fullPrice: number;
  yearlyActualPrice: number;
  rootStore: RootStore;
}> = ({ fullPrice, yearlyActualPrice, rootStore }) => {
  const {
    appStore: {
      isInSale,
      appContext: { isLimitedTimeDiscount },
      planType,
    },
  } = rootStore;
  const isProductDiscounted = Math.abs(fullPrice - yearlyActualPrice) < 0.01; // This check prevents JS rounding errors
  return isInSale ||
    (isLimitedTimeDiscount && planType === PlanType.Business) ? (
    <PremiumCurrencyFormatter
      render={(formatCurrency) => (
        <UiProvider>
          {({ themeName }) => {
            return (
              <Text
                dataHook='product-full-price-wrapper'
                size={themeName === Theme.Default ? 'small' : 'medium'}
                className={classNames(
                  s.discountPrice,
                  {
                    [s.hidden]: isProductDiscounted,
                  },
                  themeName,
                )}
              >
                {formatCurrency(fullPrice)}
              </Text>
            );
          }}
        </UiProvider>
      )}
    />
  ) : null;
};

export const ProductFullPrice = withInjectedRootStore(ProductFullPriceComp);
